(function () {
  "use strict";

  class BundlePicker {
    constructor(el) {
      this.el = el;
      this.cards = el.querySelectorAll(".bundle-picker__card");
      this.singleCard = el.querySelector('[data-bundle-type="single"]');
      this.bundleCard = el.querySelector('[data-bundle-type="bundle"]');

      this.singleQty = parseInt(el.dataset.singleQty, 10) || 1;

      this.form =
        el.closest('form[action$="/cart/add"]') ||
        document.querySelector('form[action$="/cart/add"]');
      this.qtyInput = this._findQtyInput();

      this.bundleTitleEl = el.querySelector("[data-bundle-title]");
      this.bundleHeaderTitleEl = el.querySelector("[data-bundle-header-title]");
      this.bundleSubtitleEl = el.querySelector("[data-bundle-subtitle]");
      this.bundleSaveEl = el.querySelector("[data-bundle-save]");
      this.singlePriceEl = el.querySelector(".bundle-picker__price--single");
      this.bundlePriceEl = el.querySelector(".bundle-picker__price--bundle");
      this.unitPriceEl = el.querySelector(
        ".bundle-picker__product-price--unit",
      );
      this.discountedUnitPriceEl = el.querySelector(
        ".bundle-picker__product-price--discounted",
      );
      this.origPriceEl = el.querySelector(
        ".bundle-picker__product-price--original",
      );
      this.singleTitleEl = el.querySelector("[data-single-title]");
      this.subtitleEl = el.querySelector("[data-single-subtitle]");
      this.paidQtyEl = el.querySelector("[data-paid-qty]");
      this.freeQtyEl = el.querySelector("[data-free-qty]");
      this.paidTitleEl = el.querySelector("[data-paid-title]");
      this.freeTitleEl = el.querySelector("[data-free-title]");
      this.chipImageEls = el.querySelectorAll("[data-bundle-chip-image]");
      this.defaultImageSrc = this.chipImageEls[0]?.getAttribute("src") || "";
      this.defaultImageAlt =
        this.chipImageEls[0]?.getAttribute("alt") || this._productTitle();
      this.plusEl = el.querySelector(".bundle-picker__plus");
      this.freeChipEl = el.querySelector(".bundle-picker__product-chip--free");
      this.perServingEl = el.querySelector("[data-per-serving]");
      this.perServingTemplate = this.perServingEl?.dataset.template || "";

      const variantsKey = el.dataset.variantsKey;
      const promosKey = el.dataset.promosKey;
      const subtitlesKey = el.dataset.subtitlesKey;
      const bundleSubtitlesKey = el.dataset.bundleSubtitlesKey;
      this.variants =
        (variantsKey && window["__bundlePickerVariants_" + variantsKey]) || [];
      this.promos =
        (promosKey && window["__bundlePickerPromos_" + promosKey]) || {};
      this.singleSubtitles =
        (subtitlesKey &&
          window["__bundlePickerSingleSubtitles_" + subtitlesKey]) ||
        {};
      this.bundleSubtitles =
        (bundleSubtitlesKey &&
          window["__bundlePickerBundleSubtitles_" + bundleSubtitlesKey]) ||
        {};
      const weightsKey = el.dataset.weightsKey;
      this.weights =
        (weightsKey && window["__bundlePickerWeights_" + weightsKey]) || {};
      this.moneyFormat = window.__bundlePickerMoneyFormat || "RM{{amount}}";
      this.currentPromo = null;
      this.currentSingleTitle = "Sticks";
      this.currentBundleTitle = "Bundle";

      this._bindEvents();
      this._selectCard(this.singleCard);
      this._startVariantWatcher();
    }

    _findQtyInput() {
      if (!this.form) return null;
      return (
        this.form.querySelector('input[name="quantity"]') ||
        this.form.querySelector(".quantity__input") ||
        this.form.querySelector("[data-quantity-input]")
      );
    }

    _findMainPriceEl() {
      const productInfoEl = this.el.closest(".product__info-container");
      const markedPriceEl = productInfoEl?.querySelector(
        "[data-bundle-main-price]",
      );
      if (markedPriceEl) return markedPriceEl;

      const sectionId = this.form?.id?.replace(/^product-form-/, "");
      if (sectionId && sectionId !== this.form?.id) {
        const priceEl = document.getElementById(`price-${sectionId}`);
        if (priceEl) return priceEl;
      }

      const sectionEl = this.el.closest('[id^="shopify-section-"]');
      return sectionEl?.querySelector('.price-wrapper[id^="price-"]') || null;
    }

    _bindEvents() {
      this.cards.forEach((card) => {
        card.addEventListener("click", () => {
          if (card.hidden) return;
          this._selectCard(card);
        });
        card.addEventListener("keydown", (e) => {
          if ((e.key === " " || e.key === "Enter") && !card.hidden) {
            e.preventDefault();
            this._selectCard(card);
          }
        });
      });

      document.addEventListener("variant:changed", (e) => {
        if (e.detail?.variant) this._onVariantChange(e.detail.variant);
      });
      this.form?.addEventListener("variant:changed", (e) => {
        if (e.detail?.variant) this._onVariantChange(e.detail.variant);
      });

      this.form
        ?.querySelector('input[name="id"]')
        ?.addEventListener("change", (e) => {
          if (e.target?.value) this._onVariantById(e.target.value);
        });
      this.qtyInput?.addEventListener("change", (e) => {
        this._updateStickyQty(e.target.value);
        this._syncAtcButtonPrice();
      });
      this.qtyInput?.addEventListener("input", (e) => {
        this._updateStickyQty(e.target.value);
        this._syncAtcButtonPrice();
      });
    }

    _startVariantWatcher() {
      const getInput = () => this.form?.querySelector('input[name="id"]');
      const input = getInput();
      if (input?.value) this._onVariantById(input.value);

      let lastId = getInput()?.value || "";
      setInterval(() => {
        const current = getInput()?.value || "";
        if (current && current !== lastId) {
          lastId = current;
          this._onVariantById(current);
        }
      }, 200);
    }

    _onVariantById(variantId) {
      const variant = this.variants.find(
        (v) => String(v.id) === String(variantId),
      );
      if (variant) this._onVariantChange(variant);
    }

    _onVariantChange(variant) {
      if (!variant) return;
      this.currentVariant = variant;
      this.currentPromo = this.promos[String(variant.id)] || null;
      this._updateVariantImages(variant);
      this._updateSubtitle(variant);
      this._applyPromo();
      this._updatePrices(variant.price);
      this._queueMainPriceSync(variant.price);
      this._updatePerServing();
    }

    _updateVariantImages(variant) {
      const imageSrc = this._variantImageSrc(variant) || this.defaultImageSrc;
      if (!imageSrc) return;

      const imageAlt = variant.title || this.defaultImageAlt;
      this.chipImageEls.forEach((img) => {
        img.src = imageSrc;
        img.alt = imageAlt;
      });
    }

    _variantImageSrc(variant) {
      const image = variant?.featured_image;
      if (!image) return "";
      if (typeof image === "string") return image;
      return image.src || image.url || "";
    }

    _updateSubtitle(variant) {
      if (!this.subtitleEl) return;
      const option = variant.option1 || variant.title || "";
      const fallbackSubtitle = option;
      const customText = this.singleSubtitles[String(variant.id)];
      if (customText) {
        const lines = this._splitMetafieldLines(customText);
        this.currentSingleTitle = lines[0] || "Sticks";
        if (this.singleTitleEl)
          this.singleTitleEl.textContent = this.currentSingleTitle;
        this.subtitleEl.textContent =
          lines.slice(1).join(" ") || fallbackSubtitle;
        this._updateHeaderTitle();
        return;
      }

      this.currentSingleTitle = "Sticks";
      if (this.singleTitleEl)
        this.singleTitleEl.textContent = this.currentSingleTitle;
      this.subtitleEl.textContent = fallbackSubtitle;
      this._updateHeaderTitle();
    }

    _applyPromo() {
      if (!this.currentPromo) {
        if (this.bundleHeaderTitleEl) this.bundleHeaderTitleEl.textContent = "";
        this.el.hidden = true;
        this.bundleCard.hidden = true;
        this._selectCard(this.singleCard);
        return;
      }

      this.el.hidden = false;
      this.bundleCard.hidden = false;

      this._updateBundleText();

      if (this.paidQtyEl)
        this.paidQtyEl.textContent = `x${this._bundlePaidDisplayQty()}`;
      if (this.freeQtyEl) this.freeQtyEl.textContent = `x${this._freeQty()}`;

      const showFree =
        this._promoType() === "buy_x_free_y" && this._freeQty() > 0;
      if (this.plusEl) this.plusEl.hidden = !showFree;
      if (this.freeChipEl) this.freeChipEl.hidden = !showFree;

      if (this.selectedCard === this.bundleCard) {
        this._setQty(this._bundleQty());
      }
      this._updateProperty(this.selectedCard === this.bundleCard);
    }

    _updateBundleText() {
      const customText = this.bundleSubtitles[String(this.currentVariantId())];
      const lines = customText ? this._splitMetafieldLines(customText) : [];

      const bundleTitle = lines[0] || "Bundle";
      this.currentBundleTitle = bundleTitle;
      if (this.bundleTitleEl) this.bundleTitleEl.textContent = bundleTitle;
      this._updateHeaderTitle();

      const subtitle = lines.slice(1).join(" ");
      if (this.bundleSubtitleEl) {
        this.bundleSubtitleEl.textContent = subtitle;
        this.bundleSubtitleEl.hidden = !subtitle;
      }
      if (this.paidTitleEl) this.paidTitleEl.textContent = this._productTitle();
      if (this.freeTitleEl) this.freeTitleEl.textContent = this._productTitle();
    }

    _splitMetafieldLines(value) {
      return String(value)
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/\\n/g, "\n")
        .split(/\r?\n|\s+\|\s+/)
        .map((line) => line.trim())
        .filter(Boolean);
    }

    _selectCard(card) {
      if (!card) return;
      this.selectedCard = card;
      const isBundle = card.dataset.bundleType === "bundle";

      this.cards.forEach((c) => {
        const selected = c === card;
        c.setAttribute("aria-checked", String(selected));
        c.classList.toggle("bundle-picker__card--selected", selected);
      });

      this._setQty(isBundle ? this._bundleQty() : this.singleQty);
      this._updateProperty(isBundle);
      this._updateHeaderTitle();
      this._syncMainPrice();
      this._queueMainPriceSync();
      this._updatePerServing();
    }

    _currentWeightGrams() {
      return Number(this.weights[String(this.currentVariantId())]) || 0;
    }

    _updatePerServing() {
      if (!this.perServingEl || !this.perServingTemplate) return;
      const unitWeight = this._currentWeightGrams();
      if (!unitWeight || !this.currentVariant?.price) {
        this.perServingEl.hidden = true;
        return;
      }
      const isBundle =
        this.selectedCard === this.bundleCard && !!this.currentPromo;
      const qty = isBundle ? Math.max(this._bundleQty(), 1) : 1;
      const totalPriceCents = isBundle
        ? this._selectedMainPriceCents()
        : this.currentVariant.price;
      const servings = (unitWeight * qty) / 3;
      if (!servings) {
        this.perServingEl.hidden = true;
        return;
      }
      this.perServingEl.textContent = this.perServingTemplate.replace(
        "[[price]]",
        this._formatMoney(totalPriceCents / servings),
      );
      this.perServingEl.hidden = false;
    }

    _updateHeaderTitle() {
      if (!this.bundleHeaderTitleEl) return;
      const title =
        this.selectedCard === this.bundleCard
          ? this.currentBundleTitle
          : this.currentSingleTitle;
      this.bundleHeaderTitleEl.textContent = title ? ` ${title}` : "";
    }

    _updateProperty(isBundle) {
      const propInput = this.form?.querySelector(
        'input[name="properties[Set]"]',
      );
      const setValue =
        isBundle && this.currentPromo
          ? this.currentBundleTitle
          : this.currentSingleTitle;

      if (propInput) propInput.value = setValue;
      this._updateStickySet(setValue);
      this._updateStickySetProperty(setValue);
    }

    _updateStickySet(value) {
      if (!value) return;
      document.querySelectorAll("[data-sticky-set]").forEach((setEl) => {
        setEl.textContent = value;
      });
    }

    _updateStickySetProperty(value) {
      if (!value) return;
      document
        .querySelectorAll("[data-sticky-set-property]")
        .forEach((input) => {
          input.value = value;
        });
    }

    _setQty(qty) {
      if (this.qtyInput) {
        this.qtyInput.value = qty;
        this.qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        this.qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
      this._updateStickyQty(qty);
    }

    _updateStickyQty(qty) {
      if (!qty) return;
      document.querySelectorAll("[data-sticky-quantity]").forEach((input) => {
        input.value = qty;
      });
    }

    _updatePrices(priceCents) {
      if (!priceCents) return;

      if (this.singlePriceEl)
        this.singlePriceEl.textContent = this._formatMoney(priceCents);

      if (!this.currentPromo) {
        this._syncMainPrice(priceCents);
        return;
      }

      const bundlePrice =
        this._promoType() === "percent"
          ? this._totalPriceCents()
          : priceCents * this._buyQty();

      const unitDisplayPrice =
        this._promoType() === "percent"
          ? priceCents * this._bundleQty()
          : priceCents;

      if (this.bundlePriceEl)
        this.bundlePriceEl.textContent = this._formatMoney(bundlePrice);
      if (this.unitPriceEl) {
        this.unitPriceEl.textContent = this._formatMoney(unitDisplayPrice);
        this.unitPriceEl.classList.toggle(
          "bundle-picker__product-price--original",
          this._promoType() === "percent",
        );
      }
      if (this.discountedUnitPriceEl) {
        this.discountedUnitPriceEl.textContent = this._formatMoney(bundlePrice);
        this.discountedUnitPriceEl.hidden = this._promoType() !== "percent";
      }
      if (this.origPriceEl)
        this.origPriceEl.textContent = this._formatMoney(priceCents);

      if (this.bundleSaveEl) {
        const saveLabel = this._saveLabel();
        this.bundleSaveEl.textContent = saveLabel;
        this.bundleSaveEl.hidden = !saveLabel;
      }

      this._syncMainPrice(priceCents);
    }

    _selectedMainPriceCents(priceCents = this.currentVariant?.price) {
      if (!priceCents) return 0;
      if (this.selectedCard === this.bundleCard && this.currentPromo) {
        return this._promoType() === "percent"
          ? this._totalPriceCents()
          : priceCents * this._buyQty();
      }
      return priceCents;
    }

    _setMainPriceText(mainPriceEl, formattedPrice) {
      if (!mainPriceEl || !formattedPrice) return;

      mainPriceEl
        .querySelectorAll(
          ".price__regular .price-item--regular, .price__sale .price-item--sale",
        )
        .forEach((amountEl) => {
          const innerPriceEl = amountEl.querySelector("span") || amountEl;
          innerPriceEl.textContent = formattedPrice;
        });
    }

    _setStickyButtonPriceText(formattedPrice) {
      if (!formattedPrice) return;
      document.querySelectorAll("[data-sticky-button-price]").forEach((el) => {
        el.textContent = formattedPrice;
      });
    }

    _atcQty() {
      const qty = parseInt(this.qtyInput?.value, 10);
      return qty > 0 ? qty : 1;
    }

    // Cart total for what the button would add: whole promo sets are charged at
    // the set price, any leftover units at the plain unit price. With no promo
    // selected the set is a single unit, so this reduces to price x quantity.
    _atcTotalPriceCents(priceCents = this.currentVariant?.price) {
      const unitPrice = priceCents || 0;
      if (!unitPrice) return 0;

      const isBundle =
        this.selectedCard === this.bundleCard && !!this.currentPromo;
      const setQty = isBundle ? Math.max(this._bundleQty(), 1) : 1;
      const setPrice = isBundle
        ? this._selectedMainPriceCents(unitPrice)
        : unitPrice;

      const qty = this._atcQty();
      const sets = Math.floor(qty / setQty);
      return sets * setPrice + (qty - sets * setQty) * unitPrice;
    }

    _syncAtcButtonPrice(priceCents = this.currentVariant?.price) {
      const totalCents = this._atcTotalPriceCents(priceCents);
      if (!totalCents) return;

      const formattedPrice = this._formatMoneyWithoutTrailingZeros(totalCents);
      const scope = this.form || document;

      scope.querySelectorAll("[data-price-template]").forEach((labelEl) => {
        const template = labelEl.dataset.priceTemplate;
        if (!template) return;

        const label = template.replace("[[price]]", () => formattedPrice);
        // global.js toggleAddButton() restores the label from data-label after
        // every variant fetch, so keep it in sync or the price snaps back.
        labelEl.dataset.label = label;
        // A disabled button reads "Sold out"/"Unavailable" — leave it alone.
        if (!labelEl.closest("button")?.hasAttribute("disabled")) {
          labelEl.textContent = label;
        }
      });
    }

    _queueMainPriceSync(priceCents = this.currentVariant?.price) {
      window.requestAnimationFrame?.(() => {
        this._syncMainPrice(priceCents);
      });

      window.setTimeout(() => {
        this._syncMainPrice(priceCents);
      }, 100);
    }

    _selectedCardPriceText() {
      const priceEl =
        this.selectedCard === this.bundleCard
          ? this.bundlePriceEl
          : this.singlePriceEl;
      return priceEl?.textContent?.trim() || "";
    }

    _syncMainPrice(priceCents = this.currentVariant?.price) {
      const priceEl = this._findMainPriceEl();
      const fallbackPrice = this._selectedMainPriceCents(priceCents);
      const priceText =
        this._selectedCardPriceText() ||
        (fallbackPrice ? this._formatMoney(fallbackPrice) : "");

      this._setMainPriceText(priceEl, priceText);
      this._setStickyButtonPriceText(priceText);
      this._syncAtcButtonPrice(priceCents);
    }

    _formatMoney(cents) {
      const amount = cents / 100;
      return this.moneyFormat
        .replace("{{amount}}", amount.toFixed(2))
        .replace("{{amount_no_decimals}}", Math.floor(amount))
        .replace(
          "{{amount_with_comma_separator}}",
          amount.toFixed(2).replace(".", ","),
        );
    }

    // Mirrors Liquid's money_without_trailing_zeros, which renders the button's
    // initial label — otherwise "RM120" flips to "RM120.00" on first sync.
    _formatMoneyWithoutTrailingZeros(cents) {
      return this._formatMoney(cents).replace(/([.,])00(?!\d)/, "");
    }

    _formatPercent(value) {
      const percent = Number(value);
      if (!Number.isFinite(percent)) return "0";
      return percent.toFixed(2).replace(/\.?0+$/, "");
    }

    _promoType() {
      const value = String(this.currentPromo?.promoType || "")
        .trim()
        .toLowerCase();
      return value === "percent" ? "percent" : "buy_x_free_y";
    }

    _savingsDisplay() {
      const value = String(this.currentPromo?.savingsDisplay || "")
        .trim()
        .toLowerCase();
      return value === "amount" || value === "rm" ? "amount" : "percent";
    }

    currentVariantId() {
      return this.currentVariant?.id || "";
    }

    _productTitle() {
      return this.el.dataset.productTitle || "";
    }

    _buyQty() {
      return Math.max(parseInt(this.currentPromo?.buyQty, 10) || 1, 1);
    }

    _freeQty() {
      return Math.max(parseInt(this.currentPromo?.freeQty, 10) || 0, 0);
    }

    _totalPriceCents() {
      const value = String(this.currentPromo?.totalPrice ?? "").replace(
        ",",
        ".",
      );
      return Math.round(Math.max(parseFloat(value) || 0, 0) * 100);
    }

    _bundleQty() {
      return this._promoType() === "percent"
        ? this._buyQty()
        : this._buyQty() + this._freeQty();
    }

    _bundlePaidDisplayQty() {
      return this._promoType() === "percent"
        ? this._bundleQty()
        : this._buyQty();
    }

    _savePct() {
      if (this._promoType() === "percent") {
        const originalTotal = this._originalTotalCents();
        const savings = this._savingsCents();
        if (!originalTotal || !savings) return 0;
        return (savings / originalTotal) * 100;
      }
      const totalQty = this._bundleQty();
      if (!totalQty) return 0;
      return Math.round((this._freeQty() / totalQty) * 100);
    }

    _saveLabel() {
      if (this._savingsDisplay() === "amount") {
        const savings = this._savingsCents();
        return savings ? `- Save ${this._formatMoney(savings)}` : "";
      }

      const savePct = this._savePct();
      return savePct ? `- Save ${this._formatPercent(savePct)}%` : "";
    }

    _originalTotalCents() {
      return (this.currentVariant?.price || 0) * this._bundleQty();
    }

    _savingsCents() {
      if (!this.currentVariant?.price) return 0;

      if (this._promoType() === "percent") {
        return Math.max(
          this._originalTotalCents() - this._totalPriceCents(),
          0,
        );
      }

      return this.currentVariant.price * this._freeQty();
    }
  }

  function init() {
    document.querySelectorAll(".bundle-picker").forEach((el) => {
      if (!el._bundlePicker) el._bundlePicker = new BundlePicker(el);
    });
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();

  document.addEventListener("shopify:block:select", init);
  document.addEventListener("shopify:section:load", init);
})();
